import React from "react";
import { Link } from "react-router-dom";
import { normalizeWhatsappUrl } from "../utils/socialLinks";

function Footer({sociallink}) {
  const origin = window.location.origin
  .replace(/^https?:\/\/(www\.)?/, '');

  const whatsappHref = normalizeWhatsappUrl(sociallink?.whatsapp);
  return (
    <footer className="v-footer v-sheet theme--dark footer_color" data-booted="true">
          <div className="row no-gutters align-center justify-center">
            <div className="col col-12 px-3 py-4"><hr role="separator" aria-orientation="horizontal" className="footer-divider v-divider theme--dark" /></div>
            <div className="row no-gutters justify-space-between px-1 pl-4">
              <div className="col-lg-7 col-12 justify-center">
                
                <Link to="/terms-and-conditions" className="my-0 text-capitalize white--text pr-3 pl-1 footer v-btn v-btn--rounded v-btn--router v-btn--text theme--dark v-size--default white--text" style={{height: '30px'}}>
                  <span className="v-btn__content"><label className="footer-link-label text-decoration-underline caption">Terms and conditions</label></span>
                </Link>
                
                <Link to="/about-us" className="my-0 text-capitalize white--text pr-3 pl-1 footer v-btn v-btn--rounded v-btn--router v-btn--text theme--dark v-size--default white--text" style={{height: '30px'}}>
                  <span className="v-btn__content"><label className="footer-link-label text-decoration-underline caption">About Us</label></span>
                </Link>
                
                <Link to="/faq" className="my-0 text-capitalize white--text pr-3 pl-1 footer v-btn v-btn--rounded v-btn--router v-btn--text theme--dark v-size--default white--text" style={{height: '30px'}}>
                  <span className="v-btn__content"><label className="footer-link-label text-decoration-underline caption">FAQ</label></span>
                </Link>
                
                <Link to="/contact-us" className="my-0 text-capitalize white--text pr-3 pl-1 footer v-btn v-btn--rounded v-btn--router v-btn--text theme--dark v-size--default white--text" style={{height: '30px'}}>
                  <span className="v-btn__content"><label className="footer-link-label text-decoration-underline caption">Contact Us</label></span>
                </Link>
              </div>
            </div>
            
            <div className="pa-5 col col-12">
              <div className="row no-gutters">
                <div className="col-lg-4 col-6">
                  <div className="row no-gutters"><label className="subtitle-1 footer-link-label">Responsible Games</label></div>
                  <div className="row no-gutters"><img src="./static/svg/btm-18.svg" alt="" className="footer-icon" /></div>
                </div>
                <div className="col-lg-4 col-6">
                  <div className="row no-gutters"><label className="subtitle-1 footer-link-label">Find Us</label></div>
                  <div className="row no-gutters">
                    <a href={sociallink.instagram} target="_blank"><img src="./static/svg/btm-insta.svg" alt="" className="footer-icon" /></a>
                    <a href={sociallink.facebook} target="_blank"><img src="./static/svg/btm-fb.svg" alt="" className="footer-icon" /></a>
                    <a href={sociallink.youtube} target="_blank"><img src="./static/svg/btm-yt.svg" alt="" className="footer-icon" /></a>
                    <a href={sociallink.telegram} target="_blank"><img src="./static/svg/btm-tlg.svg" alt="" className="footer-icon" /></a>
                    {whatsappHref ? (
                      <a href={whatsappHref} target="_blank" rel="noreferrer">
                        <i
                          aria-hidden="true"
                          className="mdi mdi-whatsapp footer-icon"
                          style={{ display: 'block', lineHeight: '50px', textAlign: 'center' }}
                        />
                      </a>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            
            {/* Payment Methods Section */}
            <div className="pa-5 col col-12">
              <div className="row no-gutters">
                <div className="col-12">
                  <div className="row no-gutters mb-2"><label className="subtitle-1 footer-link-label">Payment Methods</label></div>
                  <div className="row no-gutters" style={{gap: '10px', flexWrap: 'wrap', alignItems: 'center'}}>
                    <img src="./static/image/payment/bank-deposit.png" alt="Bank Deposit" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/bkash.png" alt="bKash" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/rocket.png" alt="Rocket" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/nagad.png" alt="Nagad" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/nagad2.png" alt="Nagad" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/cryptocurrency.png" alt="Cryptocurrency" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/upay.png" alt="Upay" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/ok-wallet.png" alt="OK Wallet" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/surecash.png" alt="SureCash" style={{height: '30px', objectFit: 'contain'}} />
                    <img src="./static/image/payment/tap.png" alt="Tap" style={{height: '30px', objectFit: 'contain'}} />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="px-5 mt-12 align col col-12 pr-4 py-2">
            
            Copyright © 2025 {origin}.All rights are reserved.
    
            </div>
          </div>
        </footer>
  );
}
export default Footer;